<template>
  <div>
    <v-menu :close-on-content-click="false" v-model="menu" eager>
      <template v-slot:activator="{ on }">
        <v-chip
          :color="filters?.ticketBlocks?.length ? 'primary' : 'warning'"
          v-on="on"
          small
        >
          {{
            filters.ticketBlocks.length === totalTicketBlocks
              ? "Todos os lotes"
              : filters.ticketBlocks.length === 0
              ? "Nenhum lote"
              : `${filters.ticketBlocks.length} lote${
                  filters.ticketBlocks.length > 1 ? "s" : ""
                }`
          }}
        </v-chip>
      </template>
      <v-card class="pa-3" style="width: 290px" rounded="lg">
        <v-btn @click="toggleSelectAll" text block x-small class="mb-1">
          {{
            localFilters?.ticketBlocks?.length === totalTicketBlocks
              ? "Desmarcar todos"
              : "Marcar todos"
          }}
        </v-btn>
        <vue-perfect-scrollbar
          :settings="{ suppressScrollX: true, wheelPropagation: false }"
          style="max-height: 300px"
        >
          <div v-for="item in items" :key="item.id">
            <v-list-item
              @click.stop="toogleTicketGroup(item)"
              v-if="item.type == 'TicketGroup'"
              :class="
                ticketGroupSelectionStatus[item.tgId][0] === 'all'
                  ? 'v-list-item--active primary--text'
                  : ''
              "
              class="d-flex"
              style="margin: 0 -16px"
            >
              <v-simple-checkbox
                @click.stop="toogleTicketGroup(item)"
                :value="ticketGroupSelectionStatus[item.tgId][0] === 'all'"
                :indeterminate="
                  ticketGroupSelectionStatus[item.tgId][0] === 'some'
                "
              />
              <span class="text-14 font-weight-bold"> {{ item.title }} </span>
            </v-list-item>
            <v-list-item
              @click.stop="toggleTicketBlock(item.id)"
              v-if="item.type == 'TicketBlock'"
              :class="
                localFilters?.ticketBlocks?.includes(item.id)
                  ? 'v-list-item--active primary--text'
                  : ''
              "
              style="
                margin: 0 -16px;
                min-height: 35px !important;
                height: 30px !important;
              "
              class="pl-6 d-flex align-center"
              dense
            >
              <v-simple-checkbox
                @click.stop="toggleTicketBlock(item.id)"
                :value="localFilters.ticketBlocks.includes(item.id)"
                class="ma-0"
              />
              <span> {{ item.title }} </span>
            </v-list-item>
          </div>
        </vue-perfect-scrollbar>
        <div class="d-flex justify-space-between">
          <v-btn @click="cancel" text small class="mt-2"> Cancelar </v-btn>
          <v-btn
            @click="save"
            small
            class="mt-2"
            color="primary"
            :disabled="localFilters.ticketBlocks.length === 0"
          >
            Aplicar
          </v-btn>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "TicketBlockChipFilter",
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    ticketGroups: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    menu: false,
    localFilters: { ticketBlocks: [] },
  }),
  watch: {
    menu: {
      handler(val) {
        if (!val) this.save();
        else this.load();
      },
    },
    ticketGroups: {
      handler(val) {
        this.populateFilters();
      },
      immediate: true,
    },
    filters: {
      handler(val, oldVal) {
        if (val === oldVal) return;
        this.localFilters = val;
      },
      immediate: true,
    },
  },
  methods: {
    save() {
      this.menu = false;
      if (this.localFilters.ticketBlocks.length === 0) return;
      this.filters = Object.assign(this.filters, {
        ticketBlocks: this.localFilters.ticketBlocks,
      });
    },
    load(value) {
      this.localFilters = structuredClone(value || this.value);
    },
    cancel() {
      this.load();
      this.menu = false;
    },
    toggleSelectAll() {
      if (this.localFilters.ticketBlocks.length === this.totalTicketBlocks) {
        this.localFilters.ticketBlocks = [];
      } else {
        this.localFilters.ticketBlocks = this.ticketGroups.reduce(
          (acc, tg) => [...acc, ...tg.TicketBlock.map(({ id }) => id)],
          []
        );
      }
    },
    toggleTicketBlock(ticketBlockId) {
      if (this.localFilters.ticketBlocks.includes(ticketBlockId)) {
        this.localFilters.ticketBlocks = this.localFilters.ticketBlocks.filter(
          (tb) => tb !== ticketBlockId
        );
      } else {
        this.localFilters.ticketBlocks.push(ticketBlockId);
      }
    },
    toogleTicketGroup(ticketGroup) {
      if (this.ticketGroupSelectionStatus[ticketGroup.tgId][0] === "all") {
        this.localFilters.ticketBlocks = this.localFilters.ticketBlocks.filter(
          (tb) => !ticketGroup.ticketBlocks.includes(tb)
        );
      } else {
        var newSelection = new Set([
          ...this.localFilters.ticketBlocks,
          ...ticketGroup.ticketBlocks,
        ]);
        this.localFilters.ticketBlocks = Array.from(newSelection);
      }
    },
    populateFilters() {
      if (!this.value?.ticketBlocks?.length) {
        this.$nextTick(() => {
          this.filters = Object.assign(this.filters, {
            ticketBlocks: this.items
              .filter(({ type }) => type === "TicketBlock")
              .map(({ id }) => id),
          });
          this.load();
        });
      }
    },
  },
  computed: {
    filters: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    totalTicketBlocks() {
      return this.ticketGroups.reduce(
        (acc, tg) => acc + tg.TicketBlock.length,
        0
      );
    },
    ticketGroupSelectionStatus() {
      return this.items.reduce((acc, tg) => {
        if (tg.type == "TicketBlock") return acc;
        const selected = this.localFilters.ticketBlocks.filter((tbId) =>
          tg.ticketBlocks.includes(tbId)
        );
        acc[tg.tgId] =
          selected.length === tg.ticketBlocks.length
            ? ["all", selected.length]
            : selected.length === 0
            ? ["none", selected.length]
            : ["some", selected.length];
        return acc;
      }, {});
    },
    items() {
      return this.ticketGroups.reduce((acc, tg) => {
        acc.push({
          title: tg.name,
          type: "TicketGroup",
          tgId: tg.id,
          ticketBlocks: tg.TicketBlock.map(({ id }) => id),
        });

        tg.TicketBlock.forEach((t) => {
          acc.push({
            title: t.name,
            type: "TicketBlock",
            id: t.id,
          });
        });
        return acc;
      }, []);
    },
  },
  mounted() {
    this.populateFilters();
  },
};
</script>

<style lang="scss" scooped>
.smallInput {
  .v-input__control {
    .v-input__slot {
      .v-select__slot {
        .v-select__selections {
          input {
            width: 10px;
          }
        }
      }
    }
  }
}

.mediumInput {
  .v-input__control {
    .v-input__slot {
      .v-select__slot {
        .v-select__selections {
          input {
            width: 70px;
          }
        }
      }
    }
  }
}
</style>
